module.exports = __webpack_public_path__ + "images/cartons-cans-group-larger.png";